import * as React from 'react';
import type { SelectorProps } from '@repo/design-system-kit';
import { Selector } from '@repo/design-system-kit';
import type { PaymentMethods } from '../../constants';
import { PaymentMethodIcon } from '../payment-method-icon';
import { PaymentMethodTitle } from '../payment-method-title';

interface PaymentMethodSelectorProps extends Omit<SelectorProps, 'icon' | 'title'> {
  method: PaymentMethods;
  selectedLocale?: string;
}

export function PaymentMethodSelector({
  method,
  selectedLocale,
  ...props
}: PaymentMethodSelectorProps): React.ReactNode {
  return (
    <Selector
      data-test-payment-method-selector={method}
      icon={<PaymentMethodIcon method={method} />}
      title={<PaymentMethodTitle method={method} selectedLocale={selectedLocale} />}
      {...props}
    />
  );
}
